var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "全名", prop: "name", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写全名" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "邮箱", prop: "email", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写邮箱" },
                            model: {
                              value: _vm.inputForm.email,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "email", $$v)
                              },
                              expression: "inputForm.email",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "联系电话",
                            prop: "phone",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写联系电话" },
                            model: {
                              value: _vm.inputForm.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "phone", $$v)
                              },
                              expression: "inputForm.phone",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "预估价格",
                            prop: "price",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写预估价格" },
                            model: {
                              value: _vm.inputForm.price,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "price", $$v)
                              },
                              expression: "inputForm.price",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "消息", prop: "message", rules: [] },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写消息" },
                            model: {
                              value: _vm.inputForm.message,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "message", $$v)
                              },
                              expression: "inputForm.message",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }